import React from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import {
  FaBolt,
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaLinkedin,
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaCcVisa,
  FaCcMastercard,
  FaCcAmex,
  FaCcPaypal,
  FaGooglePay,
  FaApplePay,
  FaYoutube,
  FaWhatsapp,
} from "react-icons/fa";
const currentYear = new Date().getFullYear();

const Footer = ({ onCategoryChange }) => {
  const navigate = useNavigate();

  const handleFooterCategory = (cat) => {
    // Navigate with query param
    navigate(`/category/${cat}`);

    // Optional: keep localStorage in sync
    localStorage.setItem("activeCategory", cat);

    if (typeof onCategoryChange === "function") {
      onCategoryChange(cat);
    }

    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const socialLinks = [
    {
      icon: FaFacebook,
      url: "https://www.facebook.com/Tuckermotors2021/",
      color: "#1877F2",
    },
    {
      icon: FaInstagram,
      url: "https://www.instagram.com/tucker.ev.chargers/?hl=en",
      color: "#E4405F",
    },
    {
      icon: FaLinkedin,
      url: "https://in.linkedin.com/company/tucker-ev-chargers",
      color: "#0A66C2",
    },
    {
      icon: FaYoutube,
      url: "https://www.youtube.com/@tucker.ev.chargers",
      color: "#FF0000",
    },
    { icon: FaWhatsapp, url: "https://wa.me/918220057752", color: "#25D366" },
  ];

  return (
    <footer style={styles.footerSection}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
        .footer-link:hover { color: #D60000 !important; padding-left: 5px; }
        .social-btn:hover { background: #D60000 !important; transform: translateY(-3px); }
        .payment-icon:hover { color: #fff !important; transform: scale(1.1); }
      `}</style>

      {/* Inner Container: 80% Width to match page content */}
      <div style={styles.container}>
        {/* TOP GRID SECTION */}
        <div style={styles.grid}>
          {/* BRAND COLUMN */}
          <div style={styles.brandCol}>
            <h2 style={styles.brandTitle}>
              <div style={{ width: "160px", height: "60px" }}>
                <img
                  src="/logo2.png"
                  alt="CGRMART Logo"
                  width="160"
                  height="60"
                  style={{ objectFit: "contain" }}
                />
              </div>
            </h2>
            <p style={styles.brandDesc}>
              Powering the future of electric mobility. Top-tier EV charging
              solutions designed for speed, safety, and reliability.
            </p>
            <div style={{ display: "flex", gap: "10px" }}>
              {socialLinks.map(({ icon: Icon, url, color }, i) => (
                <a
                  key={i}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`Visit our ${Icon.name} page`}
                  style={{ textDecoration: "none" }}
                  title="Follow us on social media"
                >
                  <div
                    style={{
                      backgroundColor: "#fff",
                      borderRadius: "50%",
                      padding: "8px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Icon size={20} color={color} />
                  </div>
                </a>
              ))}
            </div>
          </div>

          {/* SHOP COLUMN */}
          <div>
            <h3 style={styles.heading}>Shop</h3>
            <ul style={styles.list}>
              {["Residential", "Commercial", "Highways"].map((item) => {
                const slug =
                  item === "Highways" ? "highway" : item.toLowerCase();

                return (
                  <li key={item} style={styles.listItem}>
                    <Link
                      to={`/category/${slug}`}
                      className="footer-link"
                      style={styles.link}
                    >
                      {item}
                    </Link>
                    {/* SEO fallback */}
                    <noscript>
                      <a href={`/category/${slug}`}>{item}</a>
                    </noscript>
                  </li>
                );
              })}
            </ul>
          </div>

          {/* SUPPORT COLUMN */}
          <div>
            <h3 style={styles.heading}>Support</h3>
            <ul style={styles.list}>
              {[
                {
                  label: "About Us",
                  link: "/aboutus",
                  show: true,
                },
                {
                  label: "Contact Us",
                  link: "/contactus",
                  show: true,
                },
                {
                  label: "Warranty Policy",
                  link: "/warranty-policy",
                  show: true,
                },
                {
                  label: "Privacy Policy",
                  link: "/privacy-policy",
                  show: true, // hidden for now
                },
                {
                  label: "Terms & Conditions",
                  link: "/terms-conditions",
                  show: true, // hidden for now
                },
                {
                  label: "Return Policy",
                  link: "/return-policy",
                  show: true, // hidden for now
                },
              ]
                .filter((item) => item.show)
                .map((item) => (
                  <li key={item.label} style={styles.listItem}>
                    <a
                      href={item.link}
                      className="footer-link"
                      style={styles.link}
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
            </ul>
          </div>

          {/* CONTACT COLUMN */}
          <div>
            <h3 style={styles.heading}>Contact</h3>
            <>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  color: "#fff",
                  marginBottom: "8px",
                }}
              >
                <FaPhone style={styles.icon} />
                <span>
                  <span
                    style={{
                      color: "#00e676",
                      fontWeight: "600",
                      fontSize: "14px",
                    }}
                  >
                    Sales:{" "}
                  </span>
                  +918220057752
                </span>
              </div>
            </>
            <div style={styles.contactItem}>
              <FaEnvelope style={styles.icon} />
              <span>support@tuckermotors.com</span>
            </div>
          </div>
        </div>

        {/* BOTTOM SECTION */}
        <div style={styles.bottomBar}>
          <div style={styles.bottomLeft}>
            <span>
              © {currentYear} <strong>CGRMART</strong> by Tucker Motor Private
              Limited. All Rights Reserved.
            </span>
          </div>

          {/* PAYMENT ICONS */}
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <span
              style={{
                fontSize: "12px",
                color: "#64748B",
                marginRight: "10px",
              }}
            >
              WE ACCEPT:
            </span>

            {[
              "https://img.icons8.com/color/48/visa.png",
              "https://upload.wikimedia.org/wikipedia/commons/0/04/Mastercard-logo.png",
              "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fa/American_Express_logo_%282018%29.svg/1280px-American_Express_logo_%282018%29.svg.png",
              "https://cdn.worldvectorlogo.com/logos/paypal-3.svg",
              "https://img.icons8.com/color/48/google-pay.png",
              "https://cdn.worldvectorlogo.com/logos/apple-11.svg",
            ].map((src, i) => (
              <div
                key={i}
                style={{
                  background: "#fff",
                  borderRadius: "6px",
                  padding: "6px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  src={src}
                  alt="payment"
                  width="40"
                  height="22"
                  style={{ objectFit: "contain" }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      <div style={{ marginTop: "10px", display: "none" }}>
        <a
          href="https://tuckermotors.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Tucker Motors
        </a>
        <a
          href="https://www.iea.org/"
          target="_blank"
          rel="noopener noreferrer"
        >
          EV Industry Insights
        </a>
        <br />
        <a
          href="https://www.tesla.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          EV Technology Reference
        </a>
      </div>
    </footer>
  );
};

const styles = {
  footerSection: {
    backgroundColor: "#0F172A",
    // background: "linear-gradient(90deg, #e97070, #351919)",
    color: "#E2E8F0",
    width: "100%", // FORCES FULL WIDTH BACKGROUND
    padding: "60px 0 25px 0",
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    // marginTop: "auto",
  },
  container: {
    width: "80%", // INNER CONTENT 80%
    maxWidth: "1600px",
    margin: "0 auto",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "40px",
    paddingBottom: "40px",
    borderBottom: "1px solid #334155",
  },
  brandCol: { paddingRight: "20px" },
  brandTitle: {
    color: "white",
    fontSize: "24px",
    fontWeight: "800",
    marginBottom: "15px",
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  brandDesc: {
    color: "#94A3B8",
    lineHeight: "1.6",
    fontSize: "14px",
    marginBottom: "20px",
    maxWidth: "320px",
  },
  socialRow: { display: "flex", gap: "10px" },
  socialBtn: {
    width: "36px",
    height: "36px",
    background: "#1E293B",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
    transition: "0.2s",
    cursor: "pointer",
  },
  heading: {
    color: "white",
    fontSize: "16px",
    fontWeight: "700",
    marginBottom: "20px",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
  list: { listStyle: "none", padding: 0, margin: 0 },
  listItem: { marginBottom: "12px" },
  link: {
    color: "#94A3B8",
    textDecoration: "none",
    fontSize: "14px",
    transition: "0.2s",
    display: "inline-block",
  },
  contactItem: {
    display: "flex",
    gap: "12px",
    marginBottom: "15px",
    alignItems: "flex-start",
    color: "#94A3B8",
    fontSize: "14px",
  },
  icon: { marginTop: "4px", color: "#D60000" },
  bottomBar: {
    paddingTop: "25px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "20px",
  },
  bottomLeft: {
    display: "flex",
    flexDirection: "column",
    gap: "5px",
    fontSize: "13px",
    color: "#64748B",
  },
  legalLinks: { display: "flex", gap: "15px" },
  legalLink: { color: "#64748B", textDecoration: "none", fontSize: "12px" },
  paymentRow: { display: "flex", alignItems: "center", gap: "12px" },
  payIcon: {
    fontSize: "28px",
    color: "#94A3B8",
    transition: "0.2s",
    cursor: "pointer",
  },
};

export default Footer;
